import {inject, NgModule} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  PreloadAllModules,
  ResolveFn,
  RouterModule,
  RouterStateSnapshot,
  Routes
} from '@angular/router';
import {Tab} from 'projects/common-module/src/lib/app-enums/tab';
import {Observable} from "rxjs";
import {UserDetails} from "@common-module/modelinterfaces/user-details.model";
import {AuthUserService} from "@common-module/app-services/auth-user.service";
import {filter, take} from "rxjs/operators";
import {UserRoleListService} from "./shared/service/user-role-list.service";
import {URole} from "@common-module/modelinterfaces/urole.model";
import {DeviceService} from "@common-module/app-services/device.service";
import {DeviceBrand} from "@common-module/modelinterfaces/device-brand.model";
import {DeviceProtocol} from "@common-module/modelinterfaces/device-protocol.model";
import {SystemComponent} from "./system/system.component";
import {LogoutComponent} from "./auth/logout/logout.component";
import {KeycloakService} from "keycloak-angular";


export const AuthUserResolver: ResolveFn<UserDetails> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authUserService: AuthUserService = inject(AuthUserService)
): Observable<UserDetails> => {
  authUserService.init();
  return authUserService.currentUserDetails$
    .pipe(
      filter<UserDetails>((user: UserDetails) => !!user),
      take(1)
    );
}

export const InitUserRoles: ResolveFn<URole[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: UserRoleListService = inject(UserRoleListService)
): Observable<URole[]> => {
  service.init();
  return service.userRoles$
    .pipe(
      filter<URole[]>((roles: URole[]) => !!roles),
      take(1)
    );
}

export const InitDeviceBrands: ResolveFn<DeviceBrand[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: DeviceService = inject(DeviceService)
): Observable<DeviceBrand[]> => {
  service.initLoadBrands();
  return service.brands$
    .pipe(
      filter<DeviceBrand[]>((brands: DeviceBrand[]) => !!brands),
      take(1)
    );
}

export const InitDeviceProtocols: ResolveFn<DeviceProtocol[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: DeviceService = inject(DeviceService)
): Observable<DeviceProtocol[]> => {
  service.initLoadProtocols();
  return service.protocols$
    .pipe(
      filter<DeviceProtocol[]>((protocols: DeviceProtocol[]) => !!protocols),
      take(1)
    );
}

export const authGuard: CanActivateFn = () => {
  const keycloak = inject(KeycloakService);
  return keycloak.isLoggedIn();
};


const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: 'main/users'},
  {path: Tab.LOGOUT, component: LogoutComponent},
  {path: Tab.MAIN, pathMatch: 'full', redirectTo: 'main/users'},
  {
    path: 'main',
    canActivate: [authGuard],
    component: SystemComponent,
    resolve: {
      authUser: AuthUserResolver,
      roles: InitUserRoles,
      deviceBrands: InitDeviceBrands,
      deviceProtocols: InitDeviceProtocols
    },
    loadChildren: () => import('./system/system.module').then(m => m.SystemModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      preloadingStrategy: PreloadAllModules
    })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}

